/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RegisterEmailRouteImport } from './routes/register_.email'
import { Route as LoginSsoLoginRouteImport } from './routes/login_.sso-login'
import { Route as LoginCallbackRouteImport } from './routes/login_.callback'
import { Route as mainLayoutRouteImport } from './routes/(main)/_layout'
import { Route as UnosOauthCallbackRouteImport } from './routes/unos_.oauth_.callback'
import { Route as mainLayoutDevicesIndexRouteImport } from './routes/(main)/_layout/devices/index'
import { Route as mainLayoutDashboardsIndexRouteImport } from './routes/(main)/_layout/dashboards/index'
import { Route as mainLayoutTeamsTeamsRouteImport } from './routes/(main)/_layout/teams/_teams'
import { Route as mainLayoutDevicesNewRouteImport } from './routes/(main)/_layout/devices/new'
import { Route as mainLayoutChatsChatsRouteImport } from './routes/(main)/_layout/chats/_chats'
import { Route as mainLayoutCasesNewRouteImport } from './routes/(main)/_layout/cases/new'
import { Route as mainLayoutCasesCasesRouteImport } from './routes/(main)/_layout/cases/_cases'
import { Route as mainLayoutCandidatesCandidatesRouteImport } from './routes/(main)/_layout/candidates/_candidates'
import { Route as mainLayoutTeamsTeamsNewRouteImport } from './routes/(main)/_layout/teams/_teams.new'
import { Route as mainLayoutTeamsTeamsTeamIdRouteImport } from './routes/(main)/_layout/teams/_teams.$teamId'
import { Route as mainLayoutDevicesDeviceIdEditRouteImport } from './routes/(main)/_layout/devices/$deviceId.edit'
import { Route as mainLayoutChatsChatsNewRouteImport } from './routes/(main)/_layout/chats/_chats.new'
import { Route as mainLayoutChatsChatsChatIdRouteImport } from './routes/(main)/_layout/chats/_chats.$chatId'
import { Route as mainLayoutCasesCasesCaseIdRouteImport } from './routes/(main)/_layout/cases/_cases.$caseId'
import { Route as mainLayoutCasesCaseIdPreferencesRouteImport } from './routes/(main)/_layout/cases/$caseId.preferences'
import { Route as mainLayoutCandidatesCandidatesNewRouteImport } from './routes/(main)/_layout/candidates/_candidates.new'
import { Route as mainLayoutCasesCasesCaseIdTasksTaskIdRouteImport } from './routes/(main)/_layout/cases/_cases.$caseId.tasks.$taskId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterEmailRoute = RegisterEmailRouteImport.update({
  id: '/register_/email',
  path: '/register/email',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSsoLoginRoute = LoginSsoLoginRouteImport.update({
  id: '/login_/sso-login',
  path: '/login/sso-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login_/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const mainLayoutRoute = mainLayoutRouteImport.update({
  id: '/(main)/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const UnosOauthCallbackRoute = UnosOauthCallbackRouteImport.update({
  id: '/unos_/oauth_/callback',
  path: '/unos/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const mainLayoutDevicesIndexRoute = mainLayoutDevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => mainLayoutRoute,
} as any)
const mainLayoutDashboardsIndexRoute =
  mainLayoutDashboardsIndexRouteImport.update({
    id: '/dashboards/',
    path: '/dashboards/',
    getParentRoute: () => mainLayoutRoute,
  } as any)
const mainLayoutTeamsTeamsRoute = mainLayoutTeamsTeamsRouteImport.update({
  id: '/teams/_teams',
  path: '/teams',
  getParentRoute: () => mainLayoutRoute,
} as any)
const mainLayoutDevicesNewRoute = mainLayoutDevicesNewRouteImport.update({
  id: '/devices/new',
  path: '/devices/new',
  getParentRoute: () => mainLayoutRoute,
} as any)
const mainLayoutChatsChatsRoute = mainLayoutChatsChatsRouteImport.update({
  id: '/chats/_chats',
  path: '/chats',
  getParentRoute: () => mainLayoutRoute,
} as any)
const mainLayoutCasesNewRoute = mainLayoutCasesNewRouteImport.update({
  id: '/cases/new',
  path: '/cases/new',
  getParentRoute: () => mainLayoutRoute,
} as any)
const mainLayoutCasesCasesRoute = mainLayoutCasesCasesRouteImport.update({
  id: '/cases/_cases',
  path: '/cases',
  getParentRoute: () => mainLayoutRoute,
} as any)
const mainLayoutCandidatesCandidatesRoute =
  mainLayoutCandidatesCandidatesRouteImport.update({
    id: '/candidates/_candidates',
    path: '/candidates',
    getParentRoute: () => mainLayoutRoute,
  } as any)
const mainLayoutTeamsTeamsNewRoute = mainLayoutTeamsTeamsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => mainLayoutTeamsTeamsRoute,
} as any)
const mainLayoutTeamsTeamsTeamIdRoute =
  mainLayoutTeamsTeamsTeamIdRouteImport.update({
    id: '/$teamId',
    path: '/$teamId',
    getParentRoute: () => mainLayoutTeamsTeamsRoute,
  } as any)
const mainLayoutDevicesDeviceIdEditRoute =
  mainLayoutDevicesDeviceIdEditRouteImport.update({
    id: '/devices/$deviceId/edit',
    path: '/devices/$deviceId/edit',
    getParentRoute: () => mainLayoutRoute,
  } as any)
const mainLayoutChatsChatsNewRoute = mainLayoutChatsChatsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => mainLayoutChatsChatsRoute,
} as any)
const mainLayoutChatsChatsChatIdRoute =
  mainLayoutChatsChatsChatIdRouteImport.update({
    id: '/$chatId',
    path: '/$chatId',
    getParentRoute: () => mainLayoutChatsChatsRoute,
  } as any)
const mainLayoutCasesCasesCaseIdRoute =
  mainLayoutCasesCasesCaseIdRouteImport.update({
    id: '/$caseId',
    path: '/$caseId',
    getParentRoute: () => mainLayoutCasesCasesRoute,
  } as any)
const mainLayoutCasesCaseIdPreferencesRoute =
  mainLayoutCasesCaseIdPreferencesRouteImport.update({
    id: '/cases/$caseId/preferences',
    path: '/cases/$caseId/preferences',
    getParentRoute: () => mainLayoutRoute,
  } as any)
const mainLayoutCandidatesCandidatesNewRoute =
  mainLayoutCandidatesCandidatesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => mainLayoutCandidatesCandidatesRoute,
  } as any)
const mainLayoutCasesCasesCaseIdTasksTaskIdRoute =
  mainLayoutCasesCasesCaseIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => mainLayoutCasesCasesCaseIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/login/callback': typeof LoginCallbackRoute
  '/login/sso-login': typeof LoginSsoLoginRoute
  '/register/email': typeof RegisterEmailRoute
  '/unos/oauth/callback': typeof UnosOauthCallbackRoute
  '/candidates': typeof mainLayoutCandidatesCandidatesRouteWithChildren
  '/cases': typeof mainLayoutCasesCasesRouteWithChildren
  '/cases/new': typeof mainLayoutCasesNewRoute
  '/chats': typeof mainLayoutChatsChatsRouteWithChildren
  '/devices/new': typeof mainLayoutDevicesNewRoute
  '/teams': typeof mainLayoutTeamsTeamsRouteWithChildren
  '/dashboards/': typeof mainLayoutDashboardsIndexRoute
  '/devices/': typeof mainLayoutDevicesIndexRoute
  '/candidates/new': typeof mainLayoutCandidatesCandidatesNewRoute
  '/cases/$caseId/preferences': typeof mainLayoutCasesCaseIdPreferencesRoute
  '/cases/$caseId': typeof mainLayoutCasesCasesCaseIdRouteWithChildren
  '/chats/$chatId': typeof mainLayoutChatsChatsChatIdRoute
  '/chats/new': typeof mainLayoutChatsChatsNewRoute
  '/devices/$deviceId/edit': typeof mainLayoutDevicesDeviceIdEditRoute
  '/teams/$teamId': typeof mainLayoutTeamsTeamsTeamIdRoute
  '/teams/new': typeof mainLayoutTeamsTeamsNewRoute
  '/cases/$caseId/tasks/$taskId': typeof mainLayoutCasesCasesCaseIdTasksTaskIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/login/callback': typeof LoginCallbackRoute
  '/login/sso-login': typeof LoginSsoLoginRoute
  '/register/email': typeof RegisterEmailRoute
  '/unos/oauth/callback': typeof UnosOauthCallbackRoute
  '/candidates': typeof mainLayoutCandidatesCandidatesRouteWithChildren
  '/cases': typeof mainLayoutCasesCasesRouteWithChildren
  '/cases/new': typeof mainLayoutCasesNewRoute
  '/chats': typeof mainLayoutChatsChatsRouteWithChildren
  '/devices/new': typeof mainLayoutDevicesNewRoute
  '/teams': typeof mainLayoutTeamsTeamsRouteWithChildren
  '/dashboards': typeof mainLayoutDashboardsIndexRoute
  '/devices': typeof mainLayoutDevicesIndexRoute
  '/candidates/new': typeof mainLayoutCandidatesCandidatesNewRoute
  '/cases/$caseId/preferences': typeof mainLayoutCasesCaseIdPreferencesRoute
  '/cases/$caseId': typeof mainLayoutCasesCasesCaseIdRouteWithChildren
  '/chats/$chatId': typeof mainLayoutChatsChatsChatIdRoute
  '/chats/new': typeof mainLayoutChatsChatsNewRoute
  '/devices/$deviceId/edit': typeof mainLayoutDevicesDeviceIdEditRoute
  '/teams/$teamId': typeof mainLayoutTeamsTeamsTeamIdRoute
  '/teams/new': typeof mainLayoutTeamsTeamsNewRoute
  '/cases/$caseId/tasks/$taskId': typeof mainLayoutCasesCasesCaseIdTasksTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/(main)/_layout': typeof mainLayoutRouteWithChildren
  '/login_/callback': typeof LoginCallbackRoute
  '/login_/sso-login': typeof LoginSsoLoginRoute
  '/register_/email': typeof RegisterEmailRoute
  '/unos_/oauth_/callback': typeof UnosOauthCallbackRoute
  '/(main)/_layout/candidates/_candidates': typeof mainLayoutCandidatesCandidatesRouteWithChildren
  '/(main)/_layout/cases/_cases': typeof mainLayoutCasesCasesRouteWithChildren
  '/(main)/_layout/cases/new': typeof mainLayoutCasesNewRoute
  '/(main)/_layout/chats/_chats': typeof mainLayoutChatsChatsRouteWithChildren
  '/(main)/_layout/devices/new': typeof mainLayoutDevicesNewRoute
  '/(main)/_layout/teams/_teams': typeof mainLayoutTeamsTeamsRouteWithChildren
  '/(main)/_layout/dashboards/': typeof mainLayoutDashboardsIndexRoute
  '/(main)/_layout/devices/': typeof mainLayoutDevicesIndexRoute
  '/(main)/_layout/candidates/_candidates/new': typeof mainLayoutCandidatesCandidatesNewRoute
  '/(main)/_layout/cases/$caseId/preferences': typeof mainLayoutCasesCaseIdPreferencesRoute
  '/(main)/_layout/cases/_cases/$caseId': typeof mainLayoutCasesCasesCaseIdRouteWithChildren
  '/(main)/_layout/chats/_chats/$chatId': typeof mainLayoutChatsChatsChatIdRoute
  '/(main)/_layout/chats/_chats/new': typeof mainLayoutChatsChatsNewRoute
  '/(main)/_layout/devices/$deviceId/edit': typeof mainLayoutDevicesDeviceIdEditRoute
  '/(main)/_layout/teams/_teams/$teamId': typeof mainLayoutTeamsTeamsTeamIdRoute
  '/(main)/_layout/teams/_teams/new': typeof mainLayoutTeamsTeamsNewRoute
  '/(main)/_layout/cases/_cases/$caseId/tasks/$taskId': typeof mainLayoutCasesCasesCaseIdTasksTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/login/callback'
    | '/login/sso-login'
    | '/register/email'
    | '/unos/oauth/callback'
    | '/candidates'
    | '/cases'
    | '/cases/new'
    | '/chats'
    | '/devices/new'
    | '/teams'
    | '/dashboards/'
    | '/devices/'
    | '/candidates/new'
    | '/cases/$caseId/preferences'
    | '/cases/$caseId'
    | '/chats/$chatId'
    | '/chats/new'
    | '/devices/$deviceId/edit'
    | '/teams/$teamId'
    | '/teams/new'
    | '/cases/$caseId/tasks/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/login/callback'
    | '/login/sso-login'
    | '/register/email'
    | '/unos/oauth/callback'
    | '/candidates'
    | '/cases'
    | '/cases/new'
    | '/chats'
    | '/devices/new'
    | '/teams'
    | '/dashboards'
    | '/devices'
    | '/candidates/new'
    | '/cases/$caseId/preferences'
    | '/cases/$caseId'
    | '/chats/$chatId'
    | '/chats/new'
    | '/devices/$deviceId/edit'
    | '/teams/$teamId'
    | '/teams/new'
    | '/cases/$caseId/tasks/$taskId'
  id:
    | '__root__'
    | '/'
    | '/forbidden'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/(main)/_layout'
    | '/login_/callback'
    | '/login_/sso-login'
    | '/register_/email'
    | '/unos_/oauth_/callback'
    | '/(main)/_layout/candidates/_candidates'
    | '/(main)/_layout/cases/_cases'
    | '/(main)/_layout/cases/new'
    | '/(main)/_layout/chats/_chats'
    | '/(main)/_layout/devices/new'
    | '/(main)/_layout/teams/_teams'
    | '/(main)/_layout/dashboards/'
    | '/(main)/_layout/devices/'
    | '/(main)/_layout/candidates/_candidates/new'
    | '/(main)/_layout/cases/$caseId/preferences'
    | '/(main)/_layout/cases/_cases/$caseId'
    | '/(main)/_layout/chats/_chats/$chatId'
    | '/(main)/_layout/chats/_chats/new'
    | '/(main)/_layout/devices/$deviceId/edit'
    | '/(main)/_layout/teams/_teams/$teamId'
    | '/(main)/_layout/teams/_teams/new'
    | '/(main)/_layout/cases/_cases/$caseId/tasks/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForbiddenRoute: typeof ForbiddenRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  mainLayoutRoute: typeof mainLayoutRouteWithChildren
  LoginCallbackRoute: typeof LoginCallbackRoute
  LoginSsoLoginRoute: typeof LoginSsoLoginRoute
  RegisterEmailRoute: typeof RegisterEmailRoute
  UnosOauthCallbackRoute: typeof UnosOauthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register_/email': {
      id: '/register_/email'
      path: '/register/email'
      fullPath: '/register/email'
      preLoaderRoute: typeof RegisterEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/sso-login': {
      id: '/login_/sso-login'
      path: '/login/sso-login'
      fullPath: '/login/sso-login'
      preLoaderRoute: typeof LoginSsoLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/callback': {
      id: '/login_/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(main)/_layout': {
      id: '/(main)/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof mainLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unos_/oauth_/callback': {
      id: '/unos_/oauth_/callback'
      path: '/unos/oauth/callback'
      fullPath: '/unos/oauth/callback'
      preLoaderRoute: typeof UnosOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(main)/_layout/devices/': {
      id: '/(main)/_layout/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof mainLayoutDevicesIndexRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/dashboards/': {
      id: '/(main)/_layout/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof mainLayoutDashboardsIndexRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/teams/_teams': {
      id: '/(main)/_layout/teams/_teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof mainLayoutTeamsTeamsRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/devices/new': {
      id: '/(main)/_layout/devices/new'
      path: '/devices/new'
      fullPath: '/devices/new'
      preLoaderRoute: typeof mainLayoutDevicesNewRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/chats/_chats': {
      id: '/(main)/_layout/chats/_chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof mainLayoutChatsChatsRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/cases/new': {
      id: '/(main)/_layout/cases/new'
      path: '/cases/new'
      fullPath: '/cases/new'
      preLoaderRoute: typeof mainLayoutCasesNewRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/cases/_cases': {
      id: '/(main)/_layout/cases/_cases'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof mainLayoutCasesCasesRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/candidates/_candidates': {
      id: '/(main)/_layout/candidates/_candidates'
      path: '/candidates'
      fullPath: '/candidates'
      preLoaderRoute: typeof mainLayoutCandidatesCandidatesRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/teams/_teams/new': {
      id: '/(main)/_layout/teams/_teams/new'
      path: '/new'
      fullPath: '/teams/new'
      preLoaderRoute: typeof mainLayoutTeamsTeamsNewRouteImport
      parentRoute: typeof mainLayoutTeamsTeamsRoute
    }
    '/(main)/_layout/teams/_teams/$teamId': {
      id: '/(main)/_layout/teams/_teams/$teamId'
      path: '/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof mainLayoutTeamsTeamsTeamIdRouteImport
      parentRoute: typeof mainLayoutTeamsTeamsRoute
    }
    '/(main)/_layout/devices/$deviceId/edit': {
      id: '/(main)/_layout/devices/$deviceId/edit'
      path: '/devices/$deviceId/edit'
      fullPath: '/devices/$deviceId/edit'
      preLoaderRoute: typeof mainLayoutDevicesDeviceIdEditRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/chats/_chats/new': {
      id: '/(main)/_layout/chats/_chats/new'
      path: '/new'
      fullPath: '/chats/new'
      preLoaderRoute: typeof mainLayoutChatsChatsNewRouteImport
      parentRoute: typeof mainLayoutChatsChatsRoute
    }
    '/(main)/_layout/chats/_chats/$chatId': {
      id: '/(main)/_layout/chats/_chats/$chatId'
      path: '/$chatId'
      fullPath: '/chats/$chatId'
      preLoaderRoute: typeof mainLayoutChatsChatsChatIdRouteImport
      parentRoute: typeof mainLayoutChatsChatsRoute
    }
    '/(main)/_layout/cases/_cases/$caseId': {
      id: '/(main)/_layout/cases/_cases/$caseId'
      path: '/$caseId'
      fullPath: '/cases/$caseId'
      preLoaderRoute: typeof mainLayoutCasesCasesCaseIdRouteImport
      parentRoute: typeof mainLayoutCasesCasesRoute
    }
    '/(main)/_layout/cases/$caseId/preferences': {
      id: '/(main)/_layout/cases/$caseId/preferences'
      path: '/cases/$caseId/preferences'
      fullPath: '/cases/$caseId/preferences'
      preLoaderRoute: typeof mainLayoutCasesCaseIdPreferencesRouteImport
      parentRoute: typeof mainLayoutRoute
    }
    '/(main)/_layout/candidates/_candidates/new': {
      id: '/(main)/_layout/candidates/_candidates/new'
      path: '/new'
      fullPath: '/candidates/new'
      preLoaderRoute: typeof mainLayoutCandidatesCandidatesNewRouteImport
      parentRoute: typeof mainLayoutCandidatesCandidatesRoute
    }
    '/(main)/_layout/cases/_cases/$caseId/tasks/$taskId': {
      id: '/(main)/_layout/cases/_cases/$caseId/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/cases/$caseId/tasks/$taskId'
      preLoaderRoute: typeof mainLayoutCasesCasesCaseIdTasksTaskIdRouteImport
      parentRoute: typeof mainLayoutCasesCasesCaseIdRoute
    }
  }
}

interface mainLayoutCandidatesCandidatesRouteChildren {
  mainLayoutCandidatesCandidatesNewRoute: typeof mainLayoutCandidatesCandidatesNewRoute
}

const mainLayoutCandidatesCandidatesRouteChildren: mainLayoutCandidatesCandidatesRouteChildren =
  {
    mainLayoutCandidatesCandidatesNewRoute:
      mainLayoutCandidatesCandidatesNewRoute,
  }

const mainLayoutCandidatesCandidatesRouteWithChildren =
  mainLayoutCandidatesCandidatesRoute._addFileChildren(
    mainLayoutCandidatesCandidatesRouteChildren,
  )

interface mainLayoutCasesCasesCaseIdRouteChildren {
  mainLayoutCasesCasesCaseIdTasksTaskIdRoute: typeof mainLayoutCasesCasesCaseIdTasksTaskIdRoute
}

const mainLayoutCasesCasesCaseIdRouteChildren: mainLayoutCasesCasesCaseIdRouteChildren =
  {
    mainLayoutCasesCasesCaseIdTasksTaskIdRoute:
      mainLayoutCasesCasesCaseIdTasksTaskIdRoute,
  }

const mainLayoutCasesCasesCaseIdRouteWithChildren =
  mainLayoutCasesCasesCaseIdRoute._addFileChildren(
    mainLayoutCasesCasesCaseIdRouteChildren,
  )

interface mainLayoutCasesCasesRouteChildren {
  mainLayoutCasesCasesCaseIdRoute: typeof mainLayoutCasesCasesCaseIdRouteWithChildren
}

const mainLayoutCasesCasesRouteChildren: mainLayoutCasesCasesRouteChildren = {
  mainLayoutCasesCasesCaseIdRoute: mainLayoutCasesCasesCaseIdRouteWithChildren,
}

const mainLayoutCasesCasesRouteWithChildren =
  mainLayoutCasesCasesRoute._addFileChildren(mainLayoutCasesCasesRouteChildren)

interface mainLayoutChatsChatsRouteChildren {
  mainLayoutChatsChatsChatIdRoute: typeof mainLayoutChatsChatsChatIdRoute
  mainLayoutChatsChatsNewRoute: typeof mainLayoutChatsChatsNewRoute
}

const mainLayoutChatsChatsRouteChildren: mainLayoutChatsChatsRouteChildren = {
  mainLayoutChatsChatsChatIdRoute: mainLayoutChatsChatsChatIdRoute,
  mainLayoutChatsChatsNewRoute: mainLayoutChatsChatsNewRoute,
}

const mainLayoutChatsChatsRouteWithChildren =
  mainLayoutChatsChatsRoute._addFileChildren(mainLayoutChatsChatsRouteChildren)

interface mainLayoutTeamsTeamsRouteChildren {
  mainLayoutTeamsTeamsTeamIdRoute: typeof mainLayoutTeamsTeamsTeamIdRoute
  mainLayoutTeamsTeamsNewRoute: typeof mainLayoutTeamsTeamsNewRoute
}

const mainLayoutTeamsTeamsRouteChildren: mainLayoutTeamsTeamsRouteChildren = {
  mainLayoutTeamsTeamsTeamIdRoute: mainLayoutTeamsTeamsTeamIdRoute,
  mainLayoutTeamsTeamsNewRoute: mainLayoutTeamsTeamsNewRoute,
}

const mainLayoutTeamsTeamsRouteWithChildren =
  mainLayoutTeamsTeamsRoute._addFileChildren(mainLayoutTeamsTeamsRouteChildren)

interface mainLayoutRouteChildren {
  mainLayoutCandidatesCandidatesRoute: typeof mainLayoutCandidatesCandidatesRouteWithChildren
  mainLayoutCasesCasesRoute: typeof mainLayoutCasesCasesRouteWithChildren
  mainLayoutCasesNewRoute: typeof mainLayoutCasesNewRoute
  mainLayoutChatsChatsRoute: typeof mainLayoutChatsChatsRouteWithChildren
  mainLayoutDevicesNewRoute: typeof mainLayoutDevicesNewRoute
  mainLayoutTeamsTeamsRoute: typeof mainLayoutTeamsTeamsRouteWithChildren
  mainLayoutDashboardsIndexRoute: typeof mainLayoutDashboardsIndexRoute
  mainLayoutDevicesIndexRoute: typeof mainLayoutDevicesIndexRoute
  mainLayoutCasesCaseIdPreferencesRoute: typeof mainLayoutCasesCaseIdPreferencesRoute
  mainLayoutDevicesDeviceIdEditRoute: typeof mainLayoutDevicesDeviceIdEditRoute
}

const mainLayoutRouteChildren: mainLayoutRouteChildren = {
  mainLayoutCandidatesCandidatesRoute:
    mainLayoutCandidatesCandidatesRouteWithChildren,
  mainLayoutCasesCasesRoute: mainLayoutCasesCasesRouteWithChildren,
  mainLayoutCasesNewRoute: mainLayoutCasesNewRoute,
  mainLayoutChatsChatsRoute: mainLayoutChatsChatsRouteWithChildren,
  mainLayoutDevicesNewRoute: mainLayoutDevicesNewRoute,
  mainLayoutTeamsTeamsRoute: mainLayoutTeamsTeamsRouteWithChildren,
  mainLayoutDashboardsIndexRoute: mainLayoutDashboardsIndexRoute,
  mainLayoutDevicesIndexRoute: mainLayoutDevicesIndexRoute,
  mainLayoutCasesCaseIdPreferencesRoute: mainLayoutCasesCaseIdPreferencesRoute,
  mainLayoutDevicesDeviceIdEditRoute: mainLayoutDevicesDeviceIdEditRoute,
}

const mainLayoutRouteWithChildren = mainLayoutRoute._addFileChildren(
  mainLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForbiddenRoute: ForbiddenRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  mainLayoutRoute: mainLayoutRouteWithChildren,
  LoginCallbackRoute: LoginCallbackRoute,
  LoginSsoLoginRoute: LoginSsoLoginRoute,
  RegisterEmailRoute: RegisterEmailRoute,
  UnosOauthCallbackRoute: UnosOauthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
